import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import {
  createAssessmentAPIEndpoint,
  EndPoints,
} from "../../../services/AssessmentServices";
import HomeworkCard from "./components/HomeworkCard";
import { Link } from "react-router-dom";

function HomeworksList() {
  const [homeworks, setHomeworks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    createAssessmentAPIEndpoint(EndPoints.availableAssessments)
      .fetchWithParams({ type: 1 })
      .then((res) => {
        console.log("Homeworks fetched successfully:", res.data);
        setHomeworks(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching homeworks:", error);
        setLoading(false);
      });
  }, []);
  return (
    <>
      <section className="section homeworks" translate="no">
        <div className="container">
          {loading ? (
            <div className="loading">Loading Homeworks...</div>
          ) : homeworks.length === 0 ? (
            <div className="no-homeworks">
              No homeworks available at the moment.
            </div>
          ) : (
            <Box className="homework-grid">
              {homeworks.map((homework) => (
                <HomeworkCard key={homework.id} homework={homework} />
              ))}
            </Box>
          )}
        </div>
      </section>
    </>
  );
}

export default HomeworksList;
